/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import axios from 'axios';
import {
  WEBSITE_API_BASE_ENDPOINT,
  REGEX_ALLOWED_COOKIE_PREFIX,
} from '../constants';

const AttributionHelpers = {
  async pageView() {
    const payload = Object.assign(
      AttributionHelpers.requiredPageView(),
      AttributionHelpers.attributionParams(),
      AttributionHelpers.utmParams(),
      AttributionHelpers._parseCookies(),
      AttributionHelpers.adNetworkParams(),
      AttributionHelpers.screenParams(),
      AttributionHelpers.queryStringToObject(),
    );
    try {
      const response = await axios.post(`${WEBSITE_API_BASE_ENDPOINT()}/visit`, payload);
      const { mops_xid } = response.data;
      window.localStorage.setItem('mops_xid', mops_xid);
      return mops_xid;
    } catch (err) {
      return err.data;
    }
  },
  requiredPageView() {
    return {
      mops_xid: window.localStorage.getItem('mops_xid') || '',
      page_url: window.location.href,
    };
  },
  attributionParams() {
    return {
      partner: window.localStorage.getItem('partner') || 'clientpay',
      partner_plan: window.localStorage.getItem('partner_plan') || 'clientpay_monthly',
      sales_rep: window.sessionStorage.getItem('sales_rep') || '',
      promo: window.sessionStorage.getItem('promo') || '',
    };
  },
  utmParams() {
    return {
      utm_source: window.localStorage.getItem('utm_source') || '',
      utm_medium: window.localStorage.getItem('utm_medium') || '',
      utm_campaign: window.localStorage.getItem('utm_campaign') || '',
      utm_content: window.localStorage.getItem('utm_content') || '',
      utm_term: window.localStorage.getItem('utm_term') || '',
      utm_initial_landing_page: window.localStorage.getItem('utm_initial_landing_page') || '',
      utm_initial_referrer: window.localStorage.getItem('utm_initial_referrer') || '',
      utm_last_referrer: window.localStorage.getItem('utm_last_referrer') || '',
      utm_visits: window.localStorage.getItem('utm_visits') || 1,
    };
  },
  adNetworkParams() {
    return {
      google_click_id: window.sessionStorage.getItem('google_click_id') || '',
      linkedin_click_id: window.sessionStorage.getItem('linkedin_click_id') || '',
      facebook_click_id: window.sessionStorage.getItem('facebook_click_id') || '',
      microsoft_click_id: window.sessionStorage.getItem('microsoft_click_id') || '',
    };
  },
  screenParams() {
    const orientation = (window.screen.width >= window.screen.height ? 'landscape' : 'portrait');
    return {
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      screen_color_depth: window.screen.colorDepth,
      screen_orientation: orientation,
    };
  },
  queryStringToObject() {
    if (window && window.location.search) {
      const kvPairs = {};
      if (typeof window.location.search === 'string') {
        window.location.search.split('&').forEach((qsItem) => {
          const [key, val] = qsItem.toString().split('=');
          const keyName = key.toString().replace('?', '');
          kvPairs[keyName] = val;
          window.localStorage.setItem(keyName, val);
        });
      }
      return kvPairs;
    }
    return {};
  },
  _parseCookies() {
    const cookies = document.cookie.toString().split('; ');
    const obj = {};
    cookies.map((cookie) => {
      const [key, value] = cookie.toString().split('=');
      if (REGEX_ALLOWED_COOKIE_PREFIX.test(key)) {
        obj[key] = value;
      }
      return cookie;
    });
    return obj;
  },
  async sendFormPayload(formPayload) {
    try {
      const response = await axios.post(`${WEBSITE_API_BASE_ENDPOINT()}/form`, formPayload);
      const receptId = response.data.form_request_id;
      window.localStorage.setItem('form_fill_receipt', receptId);
      return response.data;
    } catch (err) {
      return err.data;
    }
  },
};

export default AttributionHelpers;
